export const SET_SIDEBAR_DOCKED = '@sidebar/SET_SIDEBAR_DOCKED';
export const TOGGLE_MINIMIZED_OPEN = '@sidebar/TOGGLE_MINIMIZED_OPEN';
